// import { useState } from "react";
// import axios from "axios";

// const VideoUpload = () => {
//   const [videoUrl, setVideoUrl] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", "your-upload-preset"); // Replace with your upload preset

//     setLoading(true);

//     try {
//       const res = await axios.post(
//         "https://api.cloudinary.com/v1_1/dm6kz2x6m/video/upload",
//         formData
//       );
//       setVideoUrl(res.data.secure_url);
//     } catch (error) {
//       console.error("Upload failed:", error);
//     }

//     setLoading(false);
//   };

//   return (
//     <div>
//       <input type="file" accept="video/*" onChange={handleFileChange} />
//       {loading && <p>Uploading...</p>}
//       {videoUrl && (
//         <video width="600" controls>
//           <source src={videoUrl} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       )}
//     </div>
//   );
// };

// export default VideoUpload;

import { useState } from "react";
import axios from "axios";

const VideoUpload = () => {
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check if the file is a valid video format (MP4, AVI, WebM)
    const allowedFormats = ["video/mp4", "video/avi", "video/webm"];
    if (!allowedFormats.includes(file.type)) {
      alert("Only MP4, AVI, and WebM formats are supported.");
      return;
    }

    const formData = new FormData();
    formData.append("video", file);

    setLoading(true);

    try {
      const res = await axios.post("https://api.imgur.com/3/upload", formData, {
        headers: {
          Authorization: "3f1a6af162a051b", // Replace with your actual Client-ID
        },
      });

      console.log("res", res);

      setVideoUrl(res.data.data.link);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div>
      <input type="file" accept="video/*" onChange={handleFileChange} />
      {loading && <p>Uploading...</p>}
      {videoUrl && (
        <video width="600" controls>
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default VideoUpload;
